import React from "react";

const IconButton = ({ icon: Icon, onClick, style, text, ...props }) => {
  return (
    <div
      onClick={onClick}
      style={{
        cursor: "pointer",
        padding: "5px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        ...style,
      }}
      {...props}
    >
      <Icon />
      {text && <span>{text}</span>}
    </div>
  );
};

export default IconButton;
